<template>
  <div class="page">
    <van-nav-bar
        title="订单支付"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    />

    <div style="padding-top: 50px">
      <van-cell-group class="user-group">
        <van-cell title="订单编号" :value="orderNo"/>
        <van-cell title="订单金额" :value="payInfo.payAmount" value-class="money"/>
        <van-cell title="总余额" :value="payMes.totalBalance"/>
        <van-cell title="可用余额" :value="payMes.walletBalance"/>
        <van-checkbox-group style="padding: 15px" v-model="payTypes">
          <van-checkbox class="i-checkbox" v-for="(v,k) in payMes.meta" :name="k" :key="k">
            <div class="pay-type-warp"><span>{{ type2name[k] }}</span> <span>{{ v }}</span></div>
          </van-checkbox>
        </van-checkbox-group>

      </van-cell-group>

      <div v-if="transferredAmount>0">
        <div class="tip">
          <div class="tip-msg">
            <van-icon name="warning-o" class="tip-icon"/>
            <p style="color: red;">余额不足！</p>
            <p>请您在一小时内完成转账,否则一小时后自动取消</p>
          </div>


          <p v-if="payMes.shopId == 11" class="font-size-payType">公司：山东德恩怡华通信科技有限公司</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">账号：86611742101421002321</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">公司：山东金怡华通信发展有限公司</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">账号：000000737003800006023</p>
          <p v-if="payMes.shopId == 12" class="font-size-payType">公司：山东新松联电子科技有限公司</p>
          <p v-if="payMes.shopId == 12" class="font-size-payType">账号：86611742101421002369</p>
          <p v-if="payMes.shopId==13" class="font-size-payType">公司名称：山东鸿米通信科技有限公司</p>
          <p v-if="payMes.shopId==13" class="font-size-payType">账号：86611742101421002345</p>
          <p v-if="payMes.shopId==16" class="font-size-payType">公司名称：山东戴革通信设备有限公司</p>
          <p v-if="payMes.shopId==16" class="font-size-payType">账号：86611742101421002314</p>
          <p v-if="payMes.shopId==17" class="font-size-payType">公司名称：山东艾吉姆电子商务有限公司</p>
          <p v-if="payMes.shopId==17" class="font-size-payType">账号：86611742101421007179</p>
          <p v-if="payMes.shopId==18" class="font-size-payType">公司名称：山东金怡华公司（新业务）</p>
          <p v-if="payMes.shopId==18" class="font-size-payType">账号：000000737003800006023</p>
          <p v-if="payMes.shopId==24">公司名称：济南赛米电子有限公司</p>
          <p v-if="payMes.shopId==24">账号：37050161600800002638</p>
          <p v-if="payMes.shopId==20">公司名称：山东捷盛途电子科技有限公司</p>
          <p v-if="payMes.shopId==20">账号：8112501011801574691</p>
<!--          <p>开户行：齐鲁银行朝山街支行</p>-->
        </div>
        <van-cell-group class="pay">
          <van-cell title="待转款金额" v-if="transferredAmount>0" :value="transferredAmount" value-class="money"/>
          <van-checkbox v-model="payType" class="pay-type" style="font-size: 14px" name="xx">线下转账</van-checkbox>

        </van-cell-group>
      </div>
    </div>
    <!-- <div style="margin-top: 10px">
      <van-cell-group style="margin-top: 10px">
        <van-field v-model="verificationCode" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <van-button
            v-if="!showCountdown"
            slot="button"
            size="small"
            type="danger"
            :disabled="disabled"
            @click="sendVerificationCode"
          >获取验证码</van-button>
          <van-button v-else slot="button" size="small" disabled>({{countdownNum}}s)后获取</van-button>
        </van-field>
      </van-cell-group>
    </div> -->
    <div style="margin: 15px">
      <!-- <van-button size="large" type="danger" style="margin-top: 0px" :disabled="disabled||verificationCode.length<4" @click="orderSubmit">支付</van-button> -->
      <van-button
          size="large"
          type="danger"
          style="margin-top: 0px"
          @click="orderSubmit"
          :disabled="!canSubmit"
      >支付
      </van-button
      >
      <!-- :disabled="submitPayStatus" -->
    </div>

    <van-dialog
        v-model="showPaidReminder"
        title="标题"
        show-cancel-button
        cancel-button-text="我要登录手动支付"
        confirm-button-text="去开通"
        @confirm="confirmPaidReminder"
        @cancel="cancelPaidReminder"
    >
      <div style="padding: 15px">
        <p>
          为了便于您在账款不足时正常下单，系统支持
          <strong>自动支付</strong>功能
        </p>
        <h4>先下单并且进行验证，当余额充足时自动扣款功能</h4>
        <p>
          此功能全自动化，只需要给公司线下打款即可，无需二次登陆提交订单
          请确认是否开通
        </p>
        <p>此功能也可在【个人中心】--【余额】--【自动扣款】进行关闭或开启</p>
      </div>
    </van-dialog>

    <!-- 余额不足&&开通自动扣款后，弹出选择支付方式(POS/线下) -->
    <!-- <van-dialog
      v-model="insufficientWithholdingBalanceModel"
      title="余额不足"
      :showCancelButton="false"
      :before-close="confirmPayType"
    >
      <p>
        请您在一小时内完成转账,否则一小时后订单自动取消
      </p>
      <van-radio-group v-model="payType">
        <van-radio name="XX">线下转账</van-radio>
          <p v-if="payMes.shopId == 11" class="font-size-payType">公司名称：山东德恩怡华通信科技有限公司</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">账号：86611742101421002321</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">公司名称：山东金怡华通信发展有限公司</p>
          <p v-if="payMes.shopId == 11" class="font-size-payType">账号：000000737003800006023</p>
          <p v-if="payMes.shopId == 12" class="font-size-payType">公司名称：山东新松联电子科技有限公司</p>
          <p v-if="payMes.shopId == 12" class="font-size-payType">账号：86611742101421002369</p>
          <p>开户行：齐鲁银行朝山街支行</p>
        <div v-if="enablePos === true">
          <van-radio name="POS">POS支付</van-radio>
        <p class="font-size-payType">pos输入订单号：{{ orderNo }}</p>
        <p class="font-size-payType">
          转入:<span class="money">￥{{ payMes.transferredAmount }}</span
          >元
        </p>
        </div>
      </van-radio-group>
    </van-dialog> -->
  </div>
</template>

<script>
import {Toast, Notify} from "vant";
import bus from "../../bus";
import {
  getPayInfo,
  getPay,
  getVerificationCode,
  paidReminder,
  pay,
} from "../../api/pay/index";
import {initOrdersNum} from "../../api/order/submit";
// import axios from "../../api/http";
// import {API} from "../../api/const";

let type2name = {
  REBATE_PAYMENT: '大盘返利',
  PRICE_GUARANTEE: '价保余额'
}
export default {
  data() {
    return {
      enablePos: false,
      orderNo: bus.state.orderCodes[0],
      payTypes: [],
      type2name,
      payType: undefined,
      payInfo: {
        shopId: 11,
        payAmount: 0,
        walletBalance: 0,
        enableWithholding: false,
        paidReminder: false,
        mobile: undefined,
        totalBalance: undefined,
      },
      verificationCode: "",
      insufficientWithholdingBalanceModel: false,
      disabled: true,
      showCountdown: false,
      countdownNum: 0,
      showPaidReminder: false,
      payMes: {
        mobile: "***********",
        totalBalance: 0,
        walletBalance: 0,
        transferredAmount: 0,
        shopId: undefined,
      },
    };
  },
  mounted() {
    // this.currUserPos();
    this.loadData();
    this.getPay();
  },
  computed: {
    transferredAmount() {
      let num = 0
      if (this.payTypes.filter(o => o === 'REBATE_PAYMENT').length > 0) {
        num += this.payMes.meta['REBATE_PAYMENT']
      }
      if (this.payTypes.filter(o => o === 'PRICE_GUARANTEE').length > 0) {
        num += this.payMes.meta['PRICE_GUARANTEE']
      }
      const result = new BigDecimal(String(this.payInfo.payAmount))
          .subtract(new BigDecimal(String(this.payMes.walletBalance)))
          .subtract(new BigDecimal(String(num)))
      return Number(result.toString())
    },
    canSubmit() {
      return this.transferredAmount <= 0 || this.payType
    }
  },
  methods: {
    // onPayTypeChange(item) {
    //   if (item === "POS") {
    //     // 发送请求
    //     axios
    //         .post(API + "/pay/pos/" + this.orderNo, undefined)
    //         .then((res) => {
    //           console.info("goorder pos", this.payInfo);
    //           this.submitPayStatus = false;
    //         })
    //         .catch((error) => {
    //           if (error.response) {
    //             Toast(error.response.data);
    //           } else {
    //             Toast("pos支付异常");
    //           }
    //         });
    //   } else {
    //     this.submitPayStatus = false;
    //   }
    // },
    // currUserPos() {
    //   axios.get(API + "/user/currUser").then((res) => {
    //     this.enablePos = res.data.pos;
    //   });
    // },
    // confirmPayType(action, done) {
    //   if (this.payType && this.payType === "POS") {
    //     // 发送请求
    //     axios
    //         .post(API + "/pay/pos/" + this.orderNo, undefined)
    //         .then((res) => {
    //           console.info("goorder pos", this.payInfo);
    //         })
    //         .catch((error) => {
    //           if (error.response) {
    //             Toast(error.response.data);
    //           } else {
    //             Toast("pos支付异常");
    //           }
    //         });
    //
    //     done();
    //   }
    //   if (this.payType == undefined) {
    //     Toast("请选择");
    //     done(false);
    //   }
    //   done();
    //   this.submitPayStatus = false;
    // },
    loadData() {
      getPayInfo(
          this.orderNo,
          (d) => {
            this.disabled = false;
            this.payInfo = d;
            if (d.payAmount > d.walletBalance) {
              this.submitPayStatus = true;
              if (d.enableWithholding) {
                // 弹框选择支付方式，线下还是pos
                this.insufficientWithholdingBalanceModel = true;
              } else if (!d.paidReminder) {
                this.showPaidReminder = true;
              } else {
                Toast({
                  duration: 0,
                  message: "余额不足请去充值",
                  icon: "fail",
                });
              }
            }
          },
          (e) => {
            if (e.indexOf("订单已支付") > -1) {
              initOrdersNum();
              setTimeout(() => {
                this.$router.push("order-list");
              }, 3000);
            }
            Notify(e);
          }
      );
    },
    getPay() {
      getPay(this.orderNo, (d) => {
        this.payMes = d[0]
        this.payMes.mobile = d[0].mobile;
        this.payMes.totalBalance = d[0].totalBalance;
        this.payMes.walletBalance = d[0].walletBalance;
        this.payMes.shopId = d[0].shopId;
        this.payMes.transferredAmount = (
            Math.floor((d[0].payAmount - d[0].walletBalance) * 100) / 100
        ).toFixed(2);
      });
    },
    sendVerificationCode() {
      getVerificationCode(
          (d) => {
            this.countdown();
            Toast.success("发送成功请注意查收");
          },
          (e) => {
            Toast.fail("发送出现异常");
          }
      );
    },
    countdown() {
      this.showCountdown = true;
      this.countdownNum = 60;
      for (let i = 60; i--; i > -1) {
        setTimeout(() => {
          this.countdownNum = i;
          if (i == 0) {
            this.showCountdown = false;
          }
        }, (60 - i) * 1000);
      }
    },
    confirmPaidReminder() {
      paidReminder((d) => {
        this.showPaidReminder = false;
        this.$router.push("user");
      });
    },
    cancelPaidReminder() {
      paidReminder((d) => {
        this.showPaidReminder = false;
      });
    },
    orderSubmit() {
      let payInfo = {
        verificationCode: this.verificationCode,
        orderCodes: [this.orderNo],
        payTypes: this.payTypes
      };
      this.disabled = true;
      pay(
          payInfo,
          (d) => {
            Toast.success("支付成功");
            setTimeout(() => {
              this.$router.push("order-list");
              this.disabled = false;
            }, 3000);
          },
          (e) => {
            Toast.fail(e);
            this.disabled = false;
          }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.font-size-payType {
  //font-size: 14px;
}

.i-checkbox {
  padding-bottom: 10px;
  font-size: 12px;
}

.pay-type-warp {
  display: flex;
  justify-content: space-between;
  min-width: calc(100vw - 60px);

  > *:last-child {
    color: #ee0a24;
  }
}

.money {
  color: #ee0a24;
}

.page {
  min-height: 100vh;
  background: #f9f9f9;
}

.tip {
  margin-top: 15px;
  background: #fff;
  padding: 15px;
  font-size: 12px;
  text-align: center;

  .tip-icon {
    font-size: 2rem;
    color: #f00;
  }

  .tip-msg {
    text-align: center;
    color: #999;
  }
}

.pay-type {
  padding: 15px;
}
</style>

